import React, { useState } from 'react';
import { Search, ShoppingCart, Menu, X, ChevronRight, Check, Star, Clock, Shield, Smartphone } from 'lucide-react';



// Hero Section Component
const HeroSection = () => {
  return (
    <section className="bg-gradient-to-b from-gray-50 to-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 lg:py-24">
        <div className="text-center max-w-4xl mx-auto mb-12">
          <div className="inline-block bg-red-50 text-red-600 px-4 py-1 rounded-full text-sm font-medium mb-6">
            Detty December Deals Coming Soon!
          </div>
          <h2 className="text-5xl lg:text-7xl font-semibold tracking-tight mb-6">
            Upgrade the way<br />you Connect.
          </h2>
          <p className="text-xl text-gray-600 mb-8 max-w-2xl mx-auto">
            Shop the latest Apple devices and top gadget brands — iPhone, MacBook, AirPods, Smartwatches, and more.
          </p>
          <div className="flex flex-col sm:flex-row justify-center gap-4">
            <button className="bg-black text-white px-8 py-3 rounded-full font-medium hover:bg-gray-800 transition">
              Shop Now
            </button>
            <button className="border-2 border-black text-black px-8 py-3 rounded-full font-medium hover:bg-gray-50 transition">
              Trade in Your Device
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};


export default HeroSection